import gql from 'graphql-tag';

export const CREATE_CLOSE_REASONS = gql`
  mutation CreateBPFCloseReasons($input: CreateBPFCloseReasonsInput!) {
    bpf {
      result: createCloseReasons(input: $input) {
        error
        success
        entities {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
